// extracted by mini-css-extract-plugin
module.exports = {"spinWrapper":"Spinner_spinWrapper__3v2H_"};